import React, { useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import Pagination from '../Pagination/Pagination';
import TableComponent from '../table';
import MobileList from '../mobileList/MobileList';
import ScrollContainer from 'react-indiana-drag-scroll';

function MDTable({ tableData, tableColumns, searchKey, count = 0, page = 0, changePage }) {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        {
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [windowDimensions]);

    function getWindowDimensions() {
        const { innerWidth: width, innerHeight: height } = window;
        return { width, height };
    }

    return (
        <Box>
            {windowDimensions.width > 426 ? (
                <ScrollContainer className="scroll-container">
                    <TableComponent data={tableData} columns={tableColumns} />
                </ScrollContainer>
            ) : (
                <MobileList COLUMNS={tableColumns} dataJson={tableData} searchKey={searchKey} />
            )}
            <Pagination count={count} page={page} changePage={changePage} />
        </Box>
    );
}

export default MDTable;
